import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStop = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 19,
	fill: "none",
	viewBox: "0 0 19 19",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M5.75 13.25h7.5v-7.5h-7.5v7.5ZM9.502 19c-1.314 0-2.55-.25-3.706-.748a9.596 9.596 0 0 1-3.017-2.03 9.595 9.595 0 0 1-2.03-3.016A9.246 9.246 0 0 1 0 9.502c0-1.314.25-2.55.748-3.706a9.596 9.596 0 0 1 2.03-3.017A9.594 9.594 0 0 1 5.794.75 9.246 9.246 0 0 1 9.498 0c1.314 0 2.55.25 3.706.748a9.596 9.596 0 0 1 3.017 2.03 9.594 9.594 0 0 1 2.03 3.016A9.247 9.247 0 0 1 19 9.498c0 1.314-.25 2.55-.748 3.706a9.596 9.596 0 0 1-2.03 3.017 9.595 9.595 0 0 1-3.016 2.03A9.247 9.247 0 0 1 9.502 19Z"
	})
});
export { SvgStop as ReactComponent };
